import $$ from 'cmn-utils'

const baseUrl = "/api/sys/unit/group/";
export default {
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    // get: (params) => {
    //     return $$.get(baseUrl + 'get', params)
    // },
    update: (params) => {
        return $$.post(baseUrl + 'update', params)
    },
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
}